import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import type { PreloadedState } from 'redux';

import type { WidgetRuntimeState } from '../../types/appState';
import { biMiddleware, soundMiddleware } from '../middleware';
import { isWidgetRuntimeState } from '../util/isWidgetRuntimeState';
import { rootReducer, TRootState } from './reducers';

let preloadedState: PreloadedState<TRootState> | undefined;

try {
  const preloadedRuntimeState: WidgetRuntimeState =
    window.__PRELOADED_STATE__ && JSON.parse(window.__PRELOADED_STATE__ ?? '{}');
  if (preloadedRuntimeState && isWidgetRuntimeState(preloadedRuntimeState)) {
    preloadedState = preloadedRuntimeState;
  }
} catch (e) {
} finally {
  delete window.__PRELOADED_STATE__;
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([biMiddleware, soundMiddleware]),
  preloadedState,
});

if (process.env.NODE_ENV === 'development') {
  (window as any).store = store;
  (window as any).m = require('../../../__dev__/mock').default;
}

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
